import React from 'react';

const ViewMoreButton = () => {
  return (
    <div className="view-more">
      
      <span>View More</span>
    </div>
  );
};

export default ViewMoreButton; 